import "@/App.css";
import { BookingProvider } from "@/components/flyzone/BookingProvider";
import { Navbar } from "@/components/flyzone/Navbar";
import { Hero } from "@/components/flyzone/Hero";
import { Fleet } from "@/components/flyzone/Fleet";
import { WhyChooseUs } from "@/components/flyzone/WhyChooseUs";
import { HowItWorks } from "@/components/flyzone/HowItWorks";
import { AboutPune } from "@/components/flyzone/AboutPune";
import { Reviews } from "@/components/flyzone/Reviews";
import { FAQ } from "@/components/flyzone/FAQ";
import { Contact } from "@/components/flyzone/Contact";
import { Footer } from "@/components/flyzone/Footer";
import { WhatsAppButton } from "@/components/flyzone/WhatsAppButton";
import { BookingDialog } from "@/components/flyzone/BookingDialog";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BookingProvider>
        <Navbar />
        <main>
          <Hero />
          <Fleet />
          <WhyChooseUs />
          <HowItWorks />
          <AboutPune />
          <Reviews />
          <FAQ />
          <Contact />
        </main>
        <Footer />
        <WhatsAppButton />
        <BookingDialog />
        <Toaster position="top-center" theme="dark" richColors />
      </BookingProvider>
    </div>
  );
}

export default App;
